export default "__VITE_ASSET__CmciJIrX__"